export default "__VITE_ASSET__DLiI6p22__"